import React from 'react';

import { createIcon } from '@chakra-ui/react';

import { EColor } from '../Theme';

export const HeartIcon = createIcon({
  viewBox: '0 0 21 18',
  path: (
    <path
      d="M10.5 4.1743C8.5 -0.520142 1.5 -0.0201416 1.5 5.97989C1.5 11.9799 10.5 16.9801 10.5 16.9801C10.5 16.9801 19.5 11.9799 19.5 5.97989C19.5 -0.0201416 12.5 -0.520142 10.5 4.1743Z"
      fill={EColor.Transparent}
      stroke={EColor.Black}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  ),
});
